<script>
import { useAlert } from 'dashboard/composables';
import { mapActions, mapGetters } from 'vuex';
import { apiErrorMessage } from '../../../../api/coLiving/errors';
import { CARD_CLASS, FIELD_CLASS } from '../constants';
import { parseKeywords, formatKeywords } from '../catalogForms';

// Emergency keywords are one account-wide list in the settings resource (not
// per category). The bot receives them with the category block.
export default {
  name: 'EmergencyKeywordsCard',
  data() {
    return {
      cardClass: CARD_CLASS,
      fieldClass: FIELD_CLASS,
      text: '',
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('coLivingConfig', { settings: 'getSettings' }),
  },
  watch: {
    settings: {
      immediate: true,
      handler(settings) {
        if (settings) {
          this.text = formatKeywords(settings.emergency_keywords);
        }
      },
    },
  },
  methods: {
    ...mapActions('coLivingConfig', ['saveSettings']),
    async onSave() {
      this.isSaving = true;
      try {
        await this.saveSettings({
          emergency_keywords: parseKeywords(this.text),
        });
        useAlert(this.$t('CO_LIVING.COMMON.SAVED'));
      } catch (err) {
        useAlert(apiErrorMessage(this, err, 'CO_LIVING.SETTINGS.SAVE_FAILED'));
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<template>
  <section :class="cardClass" data-testid="co-living-emergency-keywords">
    <h2 class="text-lg font-medium text-slate-900 dark:text-slate-100">
      {{ $t('CO_LIVING.CATEGORIES.KEYWORDS.TITLE') }}
    </h2>
    <p class="mt-1 mb-4 text-sm text-slate-600 dark:text-slate-300">
      {{ $t('CO_LIVING.CATEGORIES.KEYWORDS.DESCRIPTION') }}
    </p>
    <form class="grid grid-cols-1 gap-4" @submit.prevent="onSave">
      <div>
        <label
          for="co-living-emergency-keywords-input"
          class="block mb-1 text-sm text-slate-700 dark:text-slate-200"
        >
          {{ $t('CO_LIVING.CATEGORIES.KEYWORDS.LABEL') }}
        </label>
        <textarea
          id="co-living-emergency-keywords-input"
          v-model="text"
          rows="2"
          :class="fieldClass"
          :placeholder="$t('CO_LIVING.CATEGORIES.KEYWORDS.PLACEHOLDER')"
          data-testid="co-living-keywords-input"
        />
        <p class="mt-1 text-xs text-slate-500 dark:text-slate-400">
          {{ $t('CO_LIVING.CATEGORIES.KEYWORDS.HINT') }}
        </p>
      </div>
      <div>
        <woot-button
          type="submit"
          :is-loading="isSaving"
          data-testid="co-living-keywords-save"
        >
          {{ $t('CO_LIVING.COMMON.SAVE') }}
        </woot-button>
      </div>
    </form>
  </section>
</template>
